module.exports = __webpack_public_path__ + "static/media/st.00cca93c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/st.svg
// module id = 2215
// module chunks = 0